import React, { useEffect, useState } from 'react';
import ReactCardFlip from 'react-card-flip';

const Works = ({ data: { title, filterButtons, projects } }) => {
  const [flippedCards, setFlippedCards] = useState({});
  const [activeFilter, setActiveFilter] = useState(filterButtons.find(f => f.active)?.value);
  const [filteredProjects, setFilteredProjects] = useState(projects);

  useEffect(() => {
    if (activeFilter === 'all') {
      setFilteredProjects(projects);
      return;
    }

    const filtered = projects.filter(project => project.category === activeFilter);
    setFilteredProjects(filtered);
  }, [activeFilter, projects]);

  const handleCardFlip = index => {
    setFlippedCards(prev => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="card-inner active">
      <div className="card-wrap">
        <div className="content works">
          <div className="title">{title}</div>
          <div className="filter-menu filter-button-group">
            {filterButtons.map((button, index) => (
              <div
                key={index}
                className={`f_btn ${button.value === activeFilter ? 'active' : ''}`}
                onClick={() => setActiveFilter(button.value)}
              >
                <label>
                  <input type="radio" name="" value={button.value} />
                  {button.label}
                </label>
              </div>
            ))}
          </div>
          <div className="content-space noSpace resumeSection">
            <div className="row grid-items border-line-v">
              {filteredProjects.map((work, index) => (
                <div key={index} className="col-md-6 colSpace border-line-h">
                  <ReactCardFlip
                    isFlipped={flippedCards[index] || false}
                    flipDirection="horizontal"
                  >
                    <div className="box-item" onClick={() => handleCardFlip(index)}>
                      <div className="image">
                        <a href="#!" rel="noopener noreferrer" onClick={e => e.preventDefault()}>
                          <img src={work.image} alt="" />
                          <span className="info">
                            <i className={`fa ${work.icon}`} aria-hidden="true"></i>
                          </span>
                        </a>
                      </div>
                      <div className="desc">
                        <a
                          href="#!"
                          rel="noopener noreferrer"
                          className="name"
                          onClick={e => e.preventDefault()}
                        >
                          {work.name}
                        </a>
                        <div className="category">
                          {filterButtons.find(f => f.value === work.category)?.label}
                        </div>
                      </div>
                    </div>

                    <div className="box-item back-content" onClick={() => handleCardFlip(index)}>
                      <h3>{work.name}</h3>
                      <p>{work.description}</p>
                    </div>
                  </ReactCardFlip>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Works;
